import { useMemo } from "react";
import { FinancialAccountSourceType } from "@common/types/financialAccount";
import { usePayrollFinancialAccounts } from "@hooks/useFinancialAccounts";
import { SelectedTransaction } from "./transactionsBulkActionsContext";

interface Props {
    selectedArray: SelectedTransaction[];
}

export function useGustoReconciliationCouldBeApplied({ selectedArray }: Props) {
    const gustoAccounts = usePayrollFinancialAccounts();

    return useMemo(() => {
        if (gustoAccounts.length === 0) {
            return false;
        }

        const selectedTransactionsComeFromGusto = selectedArray.some(
            (t) =>
                t.financialAccount?.sourceType ===
                FinancialAccountSourceType.GUSTO,
        );

        if (selectedTransactionsComeFromGusto) {
            return false;
        }

        const selectedTransactionFirstEntityId = selectedArray[0]?.entity.id;
        const gustoAccountWithSelectedEntity = gustoAccounts.find(
            (account) =>
                account.entity?.id === selectedTransactionFirstEntityId,
        );

        if (!gustoAccountWithSelectedEntity) {
            return false;
        }
        const allSelectedTransactionsHaveSameEntity = selectedArray.every(
            (t) => t.entity.id === selectedTransactionFirstEntityId,
        );

        return allSelectedTransactionsHaveSameEntity;
    }, [gustoAccounts, selectedArray]);
}
